import { useState } from 'react';
import { useBreakpoints } from '@monorepo/nova-ui';
import { ProfileButton } from '../profile-button';
import { ProfileMenuDropdown } from './profile-menu-desktop';
import { ProfileMenuDrawer } from './profile-menu-mobile';
import { useProfileMenuOptions } from './profile-menu-options';

export const ProfileMenu = ({ userId }: { userId?: string } = {}) => {
  const { isMobile } = useBreakpoints();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isMobile) {
      setDrawerOpen(true);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setDrawerOpen(false);
  };

  const options = useProfileMenuOptions(handleClose);

  return (
    <>
      <ProfileButton
        onClick={handleButtonClick}
        active={!isMobile && Boolean(anchorEl)}
      />

      {!isMobile && (
        <ProfileMenuDropdown
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          options={options}
        />
      )}

      {isMobile && (
        <ProfileMenuDrawer
          open={drawerOpen}
          onClose={handleClose}
          options={options}
          userId={userId}
        />
      )}
    </>
  );
};
